<template>
  <v-card width="320" title="PDOK" prepend-icon="layers">
    <v-list>
      <v-list-group v-for="pdokMapFeature in pdokMapFeatures" :key="pdokMapFeature.layerKey">
        <template #activator="{ props: itemProps }">
          <v-list-item v-bind="itemProps" :title="$t(`geoLayers.${pdokMapFeature.layerKey}`)" />
        </template>

        <template #default>
          <div v-for="(feature, index) of pdokMapFeature.features" :key="index">
            <v-list-item
              v-for="[propertyKey, propertyValue] of Object.entries(feature.properties).filter(([_key, value]) => !!value)"
              :key="propertyKey"
              :title="startCase(propertyKey)"
              :subtitle="propertyValue ? String(propertyValue) : undefined"
            />
          </div>
        </template>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script setup lang="ts">
import startCase from "lodash-es/startCase"

const { pdokMapFeatures } = defineProps<{ pdokMapFeatures: Array<MapFeatureData> }>()
</script>
